var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvoiceUnpaid56Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2CFB893B-5CB1-47B2-A9F0-6461EB253881_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arveldus---Krediitkaart",
    transform: "translate(-232.000000, -462.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-35",
    transform: "translate(208.000000, 334.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-32"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(0.000000, 61.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(0.000000, 43.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Invoice-Unpaid_56px",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.5638852,-1.03584031e-16 L53.4361148,1.03584031e-16 C54.3276335,-6.01853049e-17 54.6509198,0.0928256111 54.9768457,0.267132704 C55.3027716,0.441439796 55.5585602,0.697228371 55.7328673,1.0231543 C55.9071744,1.34908022 56,1.67236646 56,2.5638852 L56,53.4361148 C56,54.3276335 55.9071744,54.6509198 55.7328673,54.9768457 C55.5585602,55.3027716 55.3027716,55.5585602 54.9768457,55.7328673 C54.6509198,55.9071744 54.3276335,56 53.4361148,56 L2.5638852,56 C1.67236646,56 1.34908022,55.9071744 1.0231543,55.7328673 C0.697228371,55.5585602 0.441439796,55.3027716 0.267132704,54.9768457 C0.0928256111,54.6509198 4.01235366e-17,54.3276335 -6.90560205e-17,53.4361148 L6.90560205e-17,2.5638852 C-4.01235366e-17,1.67236646 0.0928256111,1.34908022 0.267132704,1.0231543 C0.441439796,0.697228371 0.697228371,0.441439796 1.0231543,0.267132704 C1.34908022,0.0928256111 1.67236646,6.01853049e-17 2.5638852,-1.03584031e-16 Z",
    id: "Rectangle",
    fill: "#FFCD00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(16.000000, 12.000000)",
    stroke: "#000000",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L24,0 L24,23.6521739 C24,28.2434783 20.1882353,32 15.5294118,32 L0,32 L0,0 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,9 L18,9",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,15 L18,15",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,21 L14,21",
    id: "Stroke-7"
  })))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvoiceUnpaid56Px);
export default __webpack_public_path__ + "static/media/Icon_Invoice-Unpaid_56px.9c1f399b5bb8d070af420ce1c1014ea4.svg";
export { ForwardRef as ReactComponent };